import {ACCOUNT, PID, URL} from "utils";
import classNames from "classnames/bind";
import DefaultLoginBg from "images/login_bg_default.png";
import DongyangBg from "images/dongyang_mobile.png";
import MalaysiaBg from "images/malaysia_bg.png";
import MalaysiaLogo from "images/malaysia_logo.png";
import AccountSidePanel from "components/Login/AccountSidePanel";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);
const View = ({isPc, sideType, sideProps, handleSideType, screenSize}) => {
  const queryParams = new URLSearchParams(window.location.search);
  const getPid = queryParams.get("pid");
  const playMode = queryParams.get("mode");

  const classifyPId = () => {
    if (getPid === PID.DONGYANGUNI) return "DONGYANGUNI";
    if (getPid === PID.MALAYASIA) return "MALAYASIA";
    return "REDBRICK";
  };

  const studioType = classifyPId();
  const LOGIN_VIDEO = {
    DONGYANGUNI: URL.STUDIO_DONGYANG_VIDEO,
    REDBRICK: URL.STUDIO_REDBRICK_VIDEO,
    MALAYASIA: URL.STUDIO_MALAYSIA_VIDEO,
  };

  const LOGIN_IMG = {
    DONGYANGUNI: DongyangBg,
    REDBRICK: DefaultLoginBg,
    MALAYASIA: MalaysiaBg,
  };

  return (
    <div className={cn("studio_login")}>
      {(sideType === ACCOUNT.SIGN_IN || isPc) && (
        <div className={cn("login_bg")}>
          {screenSize > 1200 ? (
            <video src={LOGIN_VIDEO[studioType]} autoPlay="autoplay" loop="loop" muted="muted" />
          ) : (
            <>
              {studioType === "MALAYASIA" && <img alt="malaysia logo" className={styles.malaysia_logo} src={MalaysiaLogo} />}
              <img alt="login bg" src={LOGIN_IMG[studioType]} className={`${studioType === "MALAYASIA" ? styles.malaysia_bg : ""}`} />
            </>
          )}
        </div>
      )}
      <AccountSidePanel sideProps={sideProps} sideType={sideType} handleSideType={handleSideType} playMode={playMode} />
    </div>
  );
};

export default View;
